const PUSH_NOTIFICATION_SKELETON_ROW_COUNT = 4;

export const PUSH_NOTIFICATION_SKELETON_ROW_KEYS = Array.from(
  { length: PUSH_NOTIFICATION_SKELETON_ROW_COUNT },
  (_, index) => `push-notification-skeleton-${index}`,
);
